import React from "react";

const Copyright = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="copyright">
            Copyright &copy; {currentYear}{" "} <span aria-hidden="true">|</span>{" "} <a href="https://www.centaurihs.com/" target="_blank" rel="noreferrer" aria-label="Centauri Health Solutions Website (opens in a new tab)"> Centauri Health Solutions </a> <span aria-hidden="true">|</span>{" "} Powered by CHS Direct <span aria-hidden="true">|</span>{" "} <a href="https://www.centaurihs.com/privacy-policy/" target="_blank" rel="noreferrer" aria-label="Privacy Policy (opens in a new tab)"> Privacy </a> <span aria-hidden="true">|</span>{" "} <a href="https://www.centaurihs.com/terms-of-use/" target="_blank" rel="noreferrer" aria-label="Terms of Use (opens in a new tab)">Terms of Use</a>
        </div>
    )
}

export default Copyright;